import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Select from "react-select";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { commonservices } from "../../services/CommonServices";
import {
  GetMachineDropdownList,
  UpdateMachine,
  UpdateReviewComment,
} from "../../services/ReduxTookit/Slice/MachineRedux";
import { useDispatch } from "react-redux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { createPortal } from "react-dom";

const CompatibilityAndDependencies = ({
  getlist,
  machineId,
  handleclose,
  bindlist,
  versionlist,
  updatereviewcommentdata,
  geteditstatus,
  setmachinedetails,
}) => {
  const countFalseValues = () => {
    return Object.values(geteditstatus).filter((value) => value === false)
      .length;
  };
  const [MachineList, setMachineList] = useState([]);

  const [MachineLoader, setMachineLoader] = useState(false);
  const [MultiSelectValidation, setMultiSelectValidation] = useState({
    machinebanner: false,
    machinelogo: false,
  });
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    machineid: machineId ? machineId : 0,
    price: "",
    subcategoryid: 0,
    title: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: [],
    dependentmachineids: [],
    cloud: [],
    errors: {
      compatiblemachineids: [],
      dependentmachineids: [],
      ValidationRules: [
        {
          FieldName: "compatiblemachineids",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "dependentmachineids",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  async function getMachineList() {
    let body = {
      subscriberid: "",
      status: "Publish",
      categoryids: "",
      industryids: "",
    };
    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.GETMACHINEDROPDOWNLIST,
    //     body: body,
    //   },
    //   true
    // );

    // let response = apiResponse(false, resData);
    dispatch(GetMachineDropdownList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        let temp = response?.payload?.data?.data?.dataList1.map((element) => ({
          label: element?.machinename,
          value: element?.machineid,
        }));
        setMachineList(temp);
      }
    });
  }

  function handleMultiSelect(selectedOptions, tag) {
    setInput((prevInput) => ({
      ...prevInput,
      [tag]: selectedOptions
        ? selectedOptions.map((option) => ({
            label: option.label,
            value: option.value,
          }))
        : [],
    }));
  }

  const updateValue = (list) => {
    return list.map((item) => {
      const foundItem = MachineList.find(
        (x) => parseInt(x.value) === parseInt(item)
      );

      if (foundItem?.label !== "") {
        return {
          label: foundItem?.label || "",
          value: parseInt(foundItem?.value),
        };
      }
    });
  };
  useEffect(() => {
    if (MachineList.length > 0) {
      setInput((prevInput) => ({
        ...prevInput,
        machineid: getlist?.dataList1[0]?.machineid || 0,
        price: getlist?.dataList1[0]?.price || "",
        subcategoryid: getlist?.dataList1[0]?.subcategoryid || 0,
        title: getlist?.dataList2[0]?.title || "",
        osrequirmet: getlist?.dataList2[0]?.osrequirmet || "",
        storage: getlist?.dataList2[0]?.storage || "",
        ram: getlist?.dataList2[0]?.ram || "",
        cpu: getlist?.dataList2[0]?.cpu || "",
        cloud: getlist?.dataList2[0]?.cloud || [],
        compatiblemachineids: getlist?.dataList2[0]?.compatiblemachineids
          ? updateValue(getlist?.dataList2[0]?.compatiblemachineids?.split(","))
          : [],
        dependentmachineids: getlist?.dataList2[0]?.dependentmachineids
          ? updateValue(getlist?.dataList2[0]?.dependentmachineids?.split(","))
          : [],
      }));
    }
  }, [MachineList]);

  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setMachineLoader(true);
      let newbody = {
        machineid: versionlist?.machineid,
        versionnumber: versionlist?.number,
        booleanfield: updatereviewcommentdata?.booleanfield,
        commentfield: updatereviewcommentdata?.commentfield,
        commentfieldvalue: updatereviewcommentdata?.commentfieldvalue,
      };

      dispatch(UpdateReviewComment(newbody))?.then((response) => {
        if (response?.payload?.isValidate) {
          handleUpdate();
        }
        if (!response?.payload?.isValidate) {
        }
      });

      // ---------- Before Redux
      // let updateReviewResponse = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.MACHINE.UPDATE_REVIEWR_COMMENT,
      //     body: newbody,
      //   },
      //   true
      // );
      // let response = apiResponse(false, updateReviewResponse);
      // if (response?.isValidate) {
      //   handleUpdate();
      // }
      // if (!response?.isValidate) {
      // }
    }
  };
  const handleUpdate = async () => {
    let body = {
      machineid: parseInt(input?.machineid),
      price: input?.price || 0,
      subcategoryid: input?.subcategoryid || 0,
      osrequirmet: input?.osrequirmet || "",
      storage: input?.storage || "",
      ram: input?.ram || "",
      cpu: input?.cpu || "",
      cloud: input?.cloud || "",
      // compatiblemachineids: input?.compatiblemachineids || "",
      // dependentmachineids: input?.dependentmachineids || "",
    };
    //
    if (input.dependentmachineids?.length > 0) {
      body["dependentmachineids"] = input.dependentmachineids
        .map((item) => item.value)
        .join(",");
    }
    if (input.compatiblemachineids?.length > 0) {
      body["compatiblemachineids"] = input.dependentmachineids
        .map((item) => item.value)
        .join(",");
    }
    if (input?.machinedocument?.size > 0) {
      body = { ...body, machinedocument: input?.machinedocument };
    }
    if (countFalseValues() === 1) {
      body = { ...body, status: "In Process" };
    } else {
      body = { ...body, status: "Rejected" };
    }

    // let resData = await apiCall(
    //   {
    //     method: "PUT",
    //     url: API_URL.BASEURL + API_URL?.MACHINE?.UPDATE_MACHINE,
    //     body: body,
    //   },
    //   true
    // );

    // let response = apiResponse(true, resData, setMachineLoader);

    dispatch(UpdateMachine(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        setMachineLoader(false);
        handleclose();
        const updatedMachineDetails = {
          ...getlist,
          dataList2: getlist?.dataList2?.map((item) => ({
            ...item,
            dependentmachines: input?.dependentmachineids
              ?.map((f) => f.label?.split(","))
              .flat()
              .join(","),
            compatiblemachines: input?.compatiblemachineids
              ?.map((f) => f.label?.split(","))
              .flat()
              .join(","),
          })),
        };
        setmachinedetails(updatedMachineDetails);
      } else {
        setMachineLoader(false);
      }
    });
  };

  useEffect(() => {
    getMachineList();
  }, []);
  // Add or remove 'loadtime' class based on MachineLoader

  useEffect(() => {
    if (MachineLoader) {
      document.body.classList.add("loadtime");
    }
    // else {
    //   document.body.classList.remove('loadtime');
    // }

    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove("loadtime");
    };
  }, [MachineLoader]); // Re-run this effect when MachineLoader changes
  const LoaderPortal = ({ children }) => {
      return createPortal(children, document.body);
    };

  return (
    <div>
      {MachineLoader && (
              <LoaderPortal>
                <MainpageLoader />
              </LoaderPortal>
            )}
      <div className="machine-detail-main mt16 p-3">
        <Row>
          <Col md={12}>
            <Form.Group className="form-group mb16">
              <Form.Label className="common-label">
                Preferred Dependent Machines
              </Form.Label>
              <div
                className={`${
                  MultiSelectValidation.dependentmachineids &&
                  "error-border-line"
                }`}
              >
                <Select
                  options={MachineList}
                  isMulti
                  value={input.dependentmachineids}
                  onChange={(e) => handleMultiSelect(e, "dependentmachineids")}
                />
              </div>
              {MultiSelectValidation.dependentmachineids && (
                <p className="error-line">This Field is a required field</p>
              )}
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="form-group mb16">
              <Form.Label className="common-label">
                Compatible Machines
              </Form.Label>
              <div
                className={`${
                  MultiSelectValidation.compatiblemachineids &&
                  "error-border-line"
                }`}
              >
                <Select
                  options={MachineList}
                  isMulti
                  value={input.compatiblemachineids}
                  onChange={(e) => handleMultiSelect(e, "compatiblemachineids")}
                />
              </div>
              {MultiSelectValidation.compatiblemachineids && (
                <p className="error-line">This Field is a required field</p>
              )}
            </Form.Group>
          </Col>
          <div className="machin-detail-footer-btns">
            <button className="grey-btn" onClick={() => handleclose()}>
              Cancel
            </button>
            <button
              className="blue-btn"
              disabled={MachineLoader}
              onClick={(e) => updateReviewStatus(e)}
              // onClick={(e) => handleUpdate(e)}
            >
              {MachineLoader ? (
                // <>
                //   <span>Loading</span>{" "}
                //   <Spinner
                //     className="ms-1"
                //     animation="border"
                //     role="status"
                //     size="sm"
                //   >
                //     <span className="visually-hidden">Loading...</span>
                //   </Spinner>
                // </>
                <SubmitLoading />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </Row>
      </div>
    </div>
  );
};

export default CompatibilityAndDependencies;
